(() => {
  const close = (button) => {
    const target = window.swinger.$(`#${button.getAttribute('aria-controls')}`);

    button.setAttribute('aria-expanded', 'false');
    if (target.length) {
      window.swinger.visibility.show(target[0]);
    }
  };

  window.swinger.observer.initialize('.swinger-button-dropdown', (elem) => {
    window.swinger.visibility.observe(elem, (visible) => {
      const button = elem.querySelector('.swinger-button-dropdown__button[aria-expanded="true"]');

      if (button && !visible) {
        close(button);
      }
    });
  }, false);

  window.swinger.eventHub.register('click', '.swinger-button-dropdown__item', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const wrapper = elem.closest('.swinger-button-dropdown');
    const button = wrapper.querySelector('.swinger-button-dropdown__button');

    button.click();
  });

  document.addEventListener('click', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const wrapper = elem.closest('.swinger-button-dropdown');

    if (!wrapper) {
      window.swinger.$('.swinger-button-dropdown__button[aria-expanded="true"]').forEach(close);
    }
  }, true);
})();
